var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item){return _c('div',{key:item.name,on:{"click":function($event){return _vm.handleClickAction(item)}}},[_c('Count',{class:_vm.$style.listItem,attrs:{"count":parseInt(item.value),"countSize":"extraSmall","hasDivider":false,"label":item.name}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }